<template>
  <div>
    <form method="post" action="/pdf/test-result">
      <input type="hidden" name="_csrf" :defaultValue="csrfToken" />
      <input type="hidden" name="test_result_id" :defaultValue="testResultId" />
      <input
        type="hidden"
        name="word_category_id"
        :defaultValue="wordCategoryId"
      />
      <input type="hidden" name="math_test_id" :defaultValue="mathsTestId" />
      <input type="hidden" name="math_level_id" :defaultValue="mathsLevelId" />
      <input type="hidden" name="score" :defaultValue="JSON.stringify(score)" />
      <input type="hidden" name="student_name" :defaultValue="playerName" />
      <input type="hidden" name="test_time" :defaultValue="displayDate" />
      <input type="hidden" name="time_offset" :defaultValue="timeOffset" />
      <button type="submit" className="sf-btn-primary">Print</button>
    </form>
  </div>
</template>

<script lang="ts">
import getCsrfToken from "@/func/net/getCsrfToken";
import { Dict } from "@/types/generalTypes";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  props: {
    testResultId: { type: Number },
    wordCategoryId: { type: Number },
    mathsTestId: { type: Number },
    mathsLevelId: { type: Number },
    score: { type: Object as PropType<Dict<any> | null> },
    playerName: { type: String },
    testDate: { type: Object as PropType<Date> },
  },
  computed: {
    csrfToken(): string {
      return getCsrfToken();
    },
    date(): Date {
      return this.testDate ? this.testDate : new Date();
    },
    displayDate(): number {
      return this.date.getTime() / 1000;
    },
    timeOffset() {
      return this.date.getTimezoneOffset();
    }
  },
});
</script>
